import React, { useState, useRef } from "react";
import { Card, Row, Col, Drawer, Badge, Button, Select, Checkbox, Input, Skeleton, Tooltip } from "antd";
import { StarOutlined, CloseOutlined, CloseSquareFilled, CompassFilled, EyeOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import "../../style.css";
import "./styles.css";
import data from "../../../constants/retailPos.json";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import MoreOptionsIcon from "../../../assets/images/moreOptionsIcon.svg";
import filterList from "../../../assets/images/filterList.svg";
import gridFilterInActive from "../../../assets/images/grid_filter2.svg";
import gridFilter from "../../../assets/images/grid_filter1.svg";
import useCartStore from "../../../stores/useCartStore";
import useAuthStore from "../../../stores/useAuthStore";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useTransactionStore from "../../../stores/useTransactionStore";
import ProductFilterPanel, { ActiveFiltersBar } from "./ProductFilterPanel";
import useProductPanelFilters from "./useProductPanelFilters";
import useStockTransfer from "./useStockTransfer";
import ProductPanelTable from "./ProductPanelTable";
import { syncSingleProductByValue } from "../../../services";
import { v4 as uuidv4 } from "uuid";

const { Option } = Select;

const ProductPanelSM = (props) => {
  const {
    checkIsManualWeight,
    isProductsFilter,
    getMoreProducts,
    productListCardRef,
    selectProductInCart,
    productItems,
    setProductItems,
    productsDisplay,
    setIsProductsVisible,
    isProductsVisible,
    pickProduct,
    selectProductToCart,
    filterDrawer,
    setFilterDrawer,
    productSearchInput,
    setProductSearchInput,
    setOpen,
    productSearchInputRef,
    keyboardType,
    setKeyboardType,
    clearProductSearchResults,
    productsData,
    productSearchRef,
    handleSelectProduct,
    setProductsList,
    productsList,
    setLayoutName,
    productPanelSearchRef,
    setInputName,
    keyboard,
    searchInputRef,
    selectedProductInCart,
    setCart,
  } = props;

  const [displayBatchSelection, setDisplayBatchSelection] = useState(false);
  const [batchSetAvailable, setBatchSetAvailable] = useState([]);
  const [showArrows, setShowArrows] = useState(true);
  const [isFetchingProduct, setIsFetchingProduct] = useState(false);
  const scrollContainerRefLocal = useRef(null);

  const tillData = useAuthStore((s) => s.tillData);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const prcPrecision = currenciesList?.[0]?.prcPrecision ?? 2;

  const filters = useProductPanelFilters({
    filterDrawer,
    setFilterDrawer,
    productSearchInput,
    setProductSearchInput,
    setProductsList,
    productsList,
    setLayoutName,
    setOpen,
    setInputName,
    keyboard,
    searchInputRef,
    productPanelSearchRef,
    pickProduct,
    setIsProductsVisible,
  });

  const stock = useStockTransfer({ tillData });

  const handleFetchSingleProduct = async () => {
    const searchValue = productSearchInput?.trim();
    if (!searchValue) return;
    setIsFetchingProduct(true);
    try {
      const tillId = tillData?.tillAccess?.cwrTill?.cwrTillID;
      await syncSingleProductByValue(tillData, uuidv4(), tillId, searchValue);
      debouncedSearch(searchValue);
    } catch (err) {
      console.error("Fetch single product error:", err);
    } finally {
      setIsFetchingProduct(false);
    }
  };

  const {
    brandsData,
    categoriesData,
    selectedProductBrand,
    setSelectedProductBrand,
    selectCategoryList,
    setSelectCategoryList,
    loading,
    priceRange,
    setPriceRange,
    allProductCategories,
    displayedNonFrequentProducts,
    hasMoreNonFrequent,
    sortOrder,
    setSortOrder,
    scrollContainerRef,
    handleScrollLoad,
    frequentProducts,
    nonfrequentProducts,
    filterProducts,
    debouncedSearch,
    handleBrandCheckboxChange,
    handleCategoryCheckboxChange,
    handleSortChange,
    onFilterClose,
    onProductsClose,
    handleSearchEnter,
    categoryCounts: dbCategoryCounts,
  } = filters;

  return (
    <React.Fragment>
      {isProductsVisible ? (
        <>
          <CloseOutlined onClick={onProductsClose} style={{ fontSize: "1.2vw", cursor: "pointer", paddingLeft: "94vw", marginBottom: "1vh" }} />
          <div style={{ display: "flex", gap: "10px", margin: "1vh 1vw", alignItems: "center" }}>
            <Input
              ref={productPanelSearchRef}
              placeholder="Search for products by code/name"
              id="sm-product-search"
              onChange={(e) => {
                const value = e.target.value;
                setProductSearchInput(value);
                keyboard?.current?.setInput(value);
                debouncedSearch(value);
              }}
              style={{
                borderRadius: "7px",
                padding: "0.8vh 0.8vw",
                borderColor: "#fff",
                backgroundColor: "#fff",
                height: "5vh",
                fontSize: "1em",
                width: "80vw",
                flex: 1,
              }}
              value={productSearchInput}
              onFocus={() => {
                setOpen(true);
                setTimeout(() => {
                  setInputName("productSearch1");
                  keyboard?.current?.setInput(productSearchInput);
                }, 150);
              }}
              onPressEnter={handleSearchEnter}
              suffix={
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {productSearchInput?.length > 0 ? (
                    <CloseSquareFilled
                      style={{ fontSize: "20px", color: "#2F3856" }}
                      onClick={async () => {
                        setProductSearchInput("");
                        debouncedSearch("");
                        setTimeout(() => {
                          setOpen(false);
                          const productSearchInput = document.getElementById("sm-product-search");
                          if (productSearchInput) {
                            productSearchInput.blur();
                          }
                          keyboard?.current?.setInput("");
                        }, 200);
                      }}
                    />
                  ) : null}
                </div>
              }
              prefix={<img src={SearchIcon} alt="" onClick={handleSelectProduct} style={{ cursor: "pointer" }} />}
            />

            <Button
              // type="primary"
              onClick={handleFetchSingleProduct}
              loading={isFetchingProduct}
              disabled={!productSearchInput?.trim()}
              style={{
                height: "5vh",
                width: "130px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#2F3856",
                color: "#fff",
                borderRadius: "7px",
              }}
            >
              Fetch Item
            </Button>
          </div>
          <Scrollbars className="productScroll1">
            {/* Guard against undefined/empty productsData — fixes blank popup
                in pre-order screen when search-by-name path opens the drawer
                without populated state. (Issue #24) */}
            {(!productsData || productsData.length === 0) && (
              <div style={{ padding: "20px", textAlign: "center", color: "#999", fontSize: "1em" }}>No matching products found.</div>
            )}
            {(productsData || []).map((obj, i) => (
              <Row gutter={[15, 11]} style={{ width: "99%", backgroundColor: "#fff", marginTop: "1.5vh", height: "13vh", marginLeft: "-0.1vw", borderRadius: "10px" }}>
                <Col span={4}>
                  <img
                    style={{
                      width: "100%",
                      height: "11vh",
                      objectFit: "contain",
                      borderRadius: "5px",
                      paddingTop: "1vh",
                      alignSelf: "center",
                    }}
                    src={obj.imageurl || DefaultProductImage}
                    alt=""
                  />
                </Col>
                <Col span={16}>
                  <div style={{ maxWidth: "100%", overflow: "hidden", paddingTop: "1vh" }}>
                    <label style={{ ...data.posScreenStyles.productsCard.cardDetails.productDescr, whiteSpace: "nowrap", textOverflow: "ellipsis" }} className="productName">
                      {obj["description"]}
                    </label>
                  </div>
                  <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                    {obj["name"]}
                    <span style={{ display: "block" }}>{obj["value"]}</span>
                  </p>
                </Col>
                <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                  <span className="productDescription-kiosk" title={obj["description"]}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {obj.sunitprice} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{obj["uomName"]}
                  </span>
                  <span
                    onClick={() => {
                      pickProduct(obj);
                    }}
                    style={{ fontSize: "0.8em", color: "#fff", backgroundColor: "#2F3856", padding: "1vh 2.5vw", marginTop: "2%", borderRadius: "3px", cursor: "pointer" }}
                  >
                    ADD
                  </span>
                </Col>
                <span tabIndex={0}></span>
              </Row>
            ))}
          </Scrollbars>
        </>
      ) : null}
      {filterDrawer && (
        <Drawer
          placement="bottom"
          closable={false}
          maskClosable={true}
          autoFocus={false}
          className="filter"
          styles={{ body: { paddingBottom: 0, paddingTop: "10px", paddingLeft: "15px", paddingRight: "15px" } }}
          keyboard={true}
          onClose={() => {
            setFilterDrawer(false);
            onFilterClose();
            const cartData = { ...useCartStore.getState().cart };
            if (cartData?.items?.length === 0) {
              if (cartData?.isReturn === true) {
                delete cartData.isReturn;
              }
              if (cartData?.isBlindReceipt === true) {
                delete cartData.isBlindReceipt;
              }
              setCart(cartData);
              useTransactionStore.getState().setSelectedReturnType(null);
              useCartStore.getState().setExchangeCart(null);
            }
          }}
          id="sm-drawer-close"
          height="100%"
          open={true}
        >
          {posConfig?.enableTileView === "Y" ? (
            <Col span={24} style={{ fontSize: "1vw", padding: "0 2vw", height: "100%" }}>
              {loading ? (
                <>
                  {[...Array(12)].map((_, index) => (
                    <Card key={index} style={{ marginBottom: "1vh", padding: "12px", borderRadius: "8px" }}>
                      <Skeleton active paragraph={{ rows: 2 }} />
                    </Card>
                  ))}
                </>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <CloseOutlined
                      onClick={() => {
                        setFilterDrawer(false);
                        onFilterClose();
                        const cartData = { ...useCartStore.getState().cart };
                        if (cartData?.items?.length === 0) {
                          if (cartData?.isReturn === true) {
                            delete cartData.isReturn;
                          }
                          if (cartData?.isBlindReceipt === true) {
                            delete cartData.isBlindReceipt;
                          }
                          setCart(cartData);
                          useTransactionStore.getState().setSelectedReturnType(null);
                          useCartStore.getState().setExchangeCart(null);
                          localStorage.removeItem("selectedReturnType");
                          localStorage.removeItem("exchangeCartObj");
                        }
                      }}
                      style={{ fontSize: "1.5vw", cursor: "pointer" }}
                    />
                  </div>
                  <div style={{ display: "flex", height: "calc(100% - 30px)", gap: "16px" }}>
                    <div style={{ width: "240px", flexShrink: 0, overflowY: "auto" }}>
                      <ProductFilterPanel
                        allProductCategories={allProductCategories}
                        categoriesData={categoriesData}
                        brandsData={brandsData}
                        productsList={productsList}
                        dbCategoryCounts={dbCategoryCounts}
                        selectedCategories={selectCategoryList}
                        selectedBrands={selectedProductBrand}
                        priceRange={priceRange}
                        onCategoryChange={(cats) => {
                          setSelectCategoryList(cats);
                          filterProducts(selectedProductBrand, cats, productSearchInput, priceRange);
                        }}
                        onBrandChange={(brands) => {
                          setSelectedProductBrand(brands);
                          filterProducts(brands, selectCategoryList, productSearchInput, priceRange);
                        }}
                        onPriceRangeChange={(range) => {
                          setPriceRange(range);
                          filterProducts(selectedProductBrand, selectCategoryList, productSearchInput, range);
                        }}
                        onClearAll={() => {
                          setSelectCategoryList([]);
                          setSelectedProductBrand([]);
                          setPriceRange([null, null]);
                          filterProducts([], [], productSearchInput, [null, null]);
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
                      <Row style={{ marginBottom: "2vh", width: "100%", display: "flex", alignItems: "center" }}>
                        <Col span={16}>
                          <Input
                            ref={productPanelSearchRef}
                            placeholder="Search for products by code/name"
                            id="sm-product-search"
                            onChange={(e) => {
                              const value = e.target.value;
                              setProductSearchInput(value);
                              keyboard?.current?.setInput(value);
                              debouncedSearch(value);
                            }}
                            style={{
                              borderRadius: "7px",
                              padding: "0.8vh 0.8vw",
                              border: "1px solid #d9d9d9",
                              backgroundColor: "#fff",
                              height: "5vh",
                              fontSize: "1em",
                              marginTop: "-2vh",
                            }}
                            value={productSearchInput}
                            onFocus={() => {
                              setOpen(true);
                              setTimeout(() => {
                                setInputName("productSearch1");
                                keyboard?.current?.setInput(productSearchInput);
                              }, 150);
                            }}
                            onPressEnter={handleSearchEnter}
                            suffix={
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {productSearchInput?.length > 0 ? (
                                  <CloseSquareFilled
                                    style={{ fontSize: "20px", color: "#2F3856" }}
                                    onClick={async () => {
                                      setProductSearchInput("");
                                      debouncedSearch("");
                                      setTimeout(() => {
                                        setOpen(false);
                                        const productSearchInput = document.getElementById("sm-product-search");
                                        if (productSearchInput) {
                                          productSearchInput.blur();
                                        }
                                        keyboard?.current?.setInput("");
                                      }, 200);
                                    }}
                                  />
                                ) : null}
                              </div>
                            }
                            prefix={<img src={SearchIcon} alt="" onClick={handleSelectProduct} style={{ cursor: "pointer" }} />}
                          />
                        </Col>
                        <Col span={4} style={{ marginLeft: "0.3vw" }}>
                          <Button
                            // type="primary"
                            onClick={handleFetchSingleProduct}
                            loading={isFetchingProduct}
                            disabled={!productSearchInput?.trim()}
                            style={{
                              height: "5vh",
                              width: "130px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#2F3856",
                              color: "#fff",
                              borderRadius: "7px",
                            }}
                          >
                            Fetch Item
                          </Button>
                        </Col>
                        <Col span={3} style={{ marginLeft: "1vw" }}>
                          <Select
                            placeholder={<span style={{ fontSize: "1em", color: "#0F0718" }}>Sort</span>}
                            suffixIcon={<img src={MoreOptionsIcon} alt="" style={{ height: "1vh" }} />}
                            value={sortOrder}
                            onChange={handleSortChange}
                            allowClear
                            onClear={() => {
                              setSortOrder(null);
                              filterProducts(selectedProductBrand, selectCategoryList, productSearchInput, priceRange);
                            }}
                            style={{
                              width: "100%",
                              height: "5vh",
                              borderRadius: "7px",
                              backgroundColor: "#fff",
                              fontSize: "1em",
                            }}
                          >
                            <Option key="price_asc" value="price_asc">
                              Price: Low to High
                            </Option>
                            <Option key="price_desc" value="price_desc">
                              Price: High to Low
                            </Option>
                            <Option key="name_asc" value="name_asc">
                              Name: A to Z
                            </Option>
                          </Select>
                        </Col>
                      </Row>
                      <ActiveFiltersBar
                        selectedCategories={selectCategoryList}
                        selectedBrands={selectedProductBrand}
                        priceRange={priceRange}
                        allProductCategories={allProductCategories}
                        categoriesData={categoriesData}
                        brandsData={brandsData}
                        onRemoveCategory={(catId) => {
                          const nc = selectCategoryList.filter((id) => id !== catId);
                          setSelectCategoryList(nc);
                          filterProducts(selectedProductBrand, nc, productSearchInput, priceRange);
                        }}
                        onRemoveBrand={(brandId) => {
                          const nb = selectedProductBrand.filter((id) => id !== brandId);
                          setSelectedProductBrand(nb);
                          filterProducts(nb, selectCategoryList, productSearchInput, priceRange);
                        }}
                        onClearPriceRange={() => {
                          setPriceRange([null, null]);
                          filterProducts(selectedProductBrand, selectCategoryList, productSearchInput, [null, null]);
                        }}
                        onClearAll={() => {
                          setSelectCategoryList([]);
                          setSelectedProductBrand([]);
                          setPriceRange([null, null]);
                          filterProducts([], [], productSearchInput, [null, null]);
                        }}
                      />
                      <Scrollbars
                        style={{ flex: 1 }}
                        ref={scrollContainerRef}
                        onScrollFrame={(values) => {
                          if (values.top >= 0.95) handleScrollLoad();
                        }}
                      >
                        <>
                          {frequentProducts.length > 0 && (
                            <div style={{ marginBottom: "2vh" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3px",
                                  marginBottom: "1vh",
                                }}
                              >
                                <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>Best Sellers</h2>
                                <Badge
                                  count={frequentProducts.length}
                                  style={{
                                    backgroundColor: "#f5f5f5",
                                    color: "#0F0718",
                                    fontSize: "0.8em",
                                    padding: "0px 8px",
                                    borderRadius: "10px",
                                    marginBottom: "1vh",
                                    marginTop: "2vh",
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(5, 1fr)",
                                  gap: "14px",
                                  paddingBottom: "0",
                                }}
                              >
                                {frequentProducts
                                  .filter((product) => selectCategoryList.length === 0 || selectCategoryList.includes(product.mProductCategoryId))
                                  .map((product) => (
                                    <Card
                                      key={product.mProductId}
                                      styles={{ body: { padding: "14px" } }}
                                      style={{
                                        borderRadius: "12px",
                                        border: "1px solid #e8e8e8",
                                        cursor: "default",
                                        position: "relative",
                                        overflow: "hidden",
                                        background: "#fff",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                                        transition: "box-shadow 0.2s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.08)";
                                      }}
                                    >
                                      {/* Product Image Section */}
                                      <div
                                        style={{
                                          height: "90px",
                                          background: "#f9f9f9",
                                          borderRadius: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          marginBottom: "12px",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={product.imageurl || DefaultProductImage}
                                          alt={product.name}
                                          style={{
                                            width: product.imageurl ? "100%" : "52px",
                                            height: product.imageurl ? "100%" : "52px",
                                            objectFit: product.imageurl ? "cover" : "contain",
                                            borderRadius: product.imageurl ? "8px" : "0",
                                          }}
                                        />
                                        {product.isBestSeller && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "6px",
                                              right: "6px",
                                              backgroundColor: "#eab308",
                                              padding: "2px 6px",
                                              display: "flex",
                                              alignItems: "center",
                                              borderRadius: "10px",
                                              fontSize: "10px",
                                              fontWeight: 500,
                                              color: "#fff",
                                            }}
                                          >
                                            <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                                            Best
                                          </div>
                                        )}
                                      </div>

                                      {/* Product Info Section */}
                                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <Tooltip title={product.name}>
                                          <h3
                                            style={{
                                              fontSize: "0.88em",
                                              fontWeight: 600,
                                              color: "#0F0718",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              margin: 0,
                                              // lineHeight: "1.3",
                                            }}
                                          >
                                            {product.name}
                                          </h3>
                                        </Tooltip>

                                        <div
                                          style={{
                                            fontSize: "0.78em",
                                            color: "#8c8c8c",
                                            marginBottom: "0.25rem",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {product.value}
                                        </div>

                                        {posConfig?.showStoreSpecificStock === "Y" && <div style={{ fontSize: "0.75em", color: "#8c8c8c" }}>Stock: {product?.onhandQty ?? 0}</div>}

                                        <div
                                          style={{
                                            fontSize: "1em",
                                            fontWeight: 600,
                                            color: "#16a34a",
                                            marginTop: "4px",
                                            marginBottom: "8px",
                                          }}
                                        >
                                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                          {product.sunitprice.toFixed(prcPrecision)}
                                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                                        </div>

                                        <Button
                                          type="text"
                                          icon={<EyeOutlined />}
                                          style={{ color: "#8c8c8c", border: "1px solid #d9d9d9", fontSize: "0.8em", height: "30px", borderRadius: "6px", width: "100%" }}
                                          onClick={() => stock.handleViewStockClick(product)}
                                        >
                                          View Stock
                                        </Button>

                                        <Button
                                          type="primary"
                                          block
                                          style={{
                                            marginTop: "4px",
                                            fontSize: "0.8em",
                                            height: "30px",
                                            borderRadius: "6px",
                                            backgroundColor: "#2f3856",
                                          }}
                                          onClick={() => pickProduct(product)}
                                        >
                                          Add to Cart
                                        </Button>
                                      </div>
                                    </Card>
                                  ))}
                              </div>
                            </div>
                          )}

                          {nonfrequentProducts.length > 0 && (
                            <div style={{ marginBottom: "2vh" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3px",
                                }}
                              >
                                <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>All Products</h2>
                                <Badge
                                  count={nonfrequentProducts.length}
                                  style={{
                                    backgroundColor: "#f5f5f5",
                                    color: "#0F0718",
                                    fontSize: "0.8em",
                                    padding: "0px 8px",
                                    borderRadius: "10px",
                                    marginBottom: "1vh",
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(5, 1fr)",
                                  gap: "14px",
                                }}
                              >
                                {displayedNonFrequentProducts
                                  .filter((product) => selectCategoryList.length === 0 || selectCategoryList.includes(product.mProductCategoryId))
                                  .map((product) => (
                                    <Card
                                      key={product.mProductId}
                                      styles={{ body: { padding: "14px" } }}
                                      style={{
                                        borderRadius: "12px",
                                        border: "1px solid #e8e8e8",
                                        cursor: "default",
                                        position: "relative",
                                        overflow: "hidden",
                                        background: "#fff",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                                        transition: "box-shadow 0.2s ease",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.08)";
                                      }}
                                    >
                                      {/* Product Image Section */}
                                      <div
                                        style={{
                                          height: "90px",
                                          background: "#f9f9f9",
                                          borderRadius: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          marginBottom: "12px",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={product.imageurl || DefaultProductImage}
                                          alt={product.name}
                                          style={{
                                            width: product.imageurl ? "100%" : "52px",
                                            height: product.imageurl ? "100%" : "52px",
                                            objectFit: product.imageurl ? "cover" : "contain",
                                            borderRadius: product.imageurl ? "8px" : "0",
                                          }}
                                        />
                                        {product.isBestSeller && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "6px",
                                              right: "6px",
                                              backgroundColor: "#eab308",
                                              padding: "2px 6px",
                                              display: "flex",
                                              alignItems: "center",
                                              borderRadius: "10px",
                                              fontSize: "10px",
                                              fontWeight: 500,
                                              color: "#fff",
                                            }}
                                          >
                                            <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                                            Best
                                          </div>
                                        )}
                                      </div>

                                      {/* Product Info Section */}
                                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                        <Tooltip title={product.name}>
                                          <h3
                                            style={{
                                              fontSize: "0.9em",
                                              fontWeight: 600,
                                              color: "#0F0718",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              margin: 0,
                                              lineHeight: "1.3",
                                            }}
                                          >
                                            {product.name}
                                          </h3>
                                        </Tooltip>

                                        <div
                                          style={{
                                            fontSize: "0.80em",
                                            color: "#8c8c8c",
                                            marginBottom: "2px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {product.value}
                                        </div>

                                        {posConfig?.showStoreSpecificStock === "Y" && <div style={{ fontSize: "0.75em", color: "#8c8c8c" }}>Stock: {product?.onhandQty ?? 0}</div>}

                                        <div
                                          style={{
                                            fontSize: "1em",
                                            fontWeight: 600,
                                            color: "#16a34a",
                                            marginTop: "4px",
                                            marginBottom: "8px",
                                          }}
                                        >
                                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                          {product.sunitprice.toFixed(prcPrecision)}
                                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                                        </div>

                                        <Button
                                          type="text"
                                          icon={<EyeOutlined />}
                                          style={{
                                            color: "#595959",
                                            border: "1px solid #d9d9d9",
                                            fontSize: "0.82em",
                                            height: "34px",
                                            borderRadius: "7px",
                                            width: "100%",
                                            marginBottom: "6px",
                                          }}
                                          onClick={() => stock.handleViewStockClick(product)}
                                        >
                                          View Stock
                                        </Button>

                                        <Button
                                          type="primary"
                                          block
                                          style={{
                                            fontSize: "0.85em",
                                            height: "38px",
                                            borderRadius: "7px",
                                            backgroundColor: "#2F3856",
                                            fontWeight: 600,
                                            border: "none",
                                          }}
                                          onClick={() => pickProduct(product)}
                                        >
                                          Add to Cart
                                        </Button>
                                      </div>
                                    </Card>
                                  ))}
                              </div>
                              {hasMoreNonFrequent && (
                                <div style={{ textAlign: "center", padding: "16px" }}>
                                  <Skeleton active paragraph={{ rows: 2 }} />
                                </div>
                              )}
                            </div>
                          )}

                          {frequentProducts.length === 0 && nonfrequentProducts.length === 0 && !loading && (
                            <div style={{ textAlign: "center", padding: "48px 0" }}>
                              <CompassFilled
                                style={{
                                  fontSize: "64px",
                                  color: "#bfbfbf",
                                  marginBottom: "16px",
                                }}
                              />
                              <h3
                                style={{
                                  fontSize: "1.2em",
                                  fontWeight: "500",
                                  color: "#0F0718",
                                  marginBottom: "8px",
                                }}
                              >
                                No products found
                              </h3>
                              <p style={{ fontSize: "0.9em", color: "#4b5563" }}>Try adjusting your search or category filter</p>
                            </div>
                          )}
                        </>
                      </Scrollbars>
                    </div>
                  </div>
                </>
              )}
            </Col>
          ) : (
            <Row style={{ padding: "0", height: "83vh", fontSize: "1vw" }}>
              <Col span={4}>
                <div style={{ paddingBottom: "2vh" }}>
                  <Skeleton active loading={loading} paragraph={{ rows: 6 }}>
                    <div
                      style={{
                        height: "5vh",
                        backgroundColor: "rgba(146, 144, 152, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "1vw",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Shop By Category</span>
                    </div>
                    <div style={{ backgroundColor: "#fff", height: "33vh", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                      <Scrollbars className="productCategorySuper">
                        <Checkbox.Group
                          style={{ padding: "1.5vh 1.5vw 0px 1.5vw", color: "#0F0718" }}
                          value={selectCategoryList}
                          options={categoriesData.map((category) => ({
                            label: <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 400, fontFamily: "Inter" }}>{category.name}</span>,
                            value: category.mProductCategoryId,
                          }))}
                          onChange={handleCategoryCheckboxChange}
                        />
                      </Scrollbars>
                    </div>
                  </Skeleton>
                </div>
                <div>
                  <Skeleton active loading={loading} paragraph={{ rows: 6 }}>
                    <div
                      style={{
                        height: "5vh",
                        backgroundColor: "rgba(146, 144, 152, 0.2)",
                        display: "flex",
                        alignItems: "center, paddingLeft: 1vw",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                      }}
                    >
                      <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Brands</span>
                    </div>
                    <div style={{ backgroundColor: "#fff", height: "33vh", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                      <Scrollbars className="productCategorySuper">
                        {brandsData.map((item, i) => (
                          <div style={{ padding: "0.8vh 1.5vw 0px" }} key={i}>
                            <Checkbox
                              id={`sm-checkbox-${item.name}`}
                              checked={selectedProductBrand?.includes(item.brandId)}
                              onChange={() => handleBrandCheckboxChange(item.brandId)}
                            />
                            <span
                              onClick={() => handleBrandCheckboxChange(item.brandId)}
                              style={{
                                whiteSpace: "nowrap",
                                alignSelf: "center",
                                padding: "2px 10px",
                                fontSize: "1em",
                                backgroundColor: selectedProductBrand?.includes(item.brandId) ? "#2F3856" : "#fff",
                                borderRadius: "7px",
                                color: selectedProductBrand?.includes(item.brandId) ? "#fff" : "#0F0718",
                                cursor: "pointer",
                                fontFamily: "Inter",
                                fontWeight: 400,
                              }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </Scrollbars>
                    </div>
                  </Skeleton>
                </div>
              </Col>
              <Col span={19} offset={1} style={{ fontSize: "1vw" }}>
                {loading ? (
                  <>
                    {[...Array(10)].map((_, index) => (
                      <React.Fragment key={index}>
                        <Skeleton.Button block />
                        <br />
                        <br />
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <CloseOutlined
                        onClick={() => {
                          setFilterDrawer(false);
                          onFilterClose();
                          const cartData = { ...useCartStore.getState().cart };
                          if (cartData?.items?.length === 0) {
                            if (cartData?.isReturn === true) {
                              delete cartData.isReturn;
                            }
                            if (cartData?.isBlindReceipt === true) {
                              delete cartData.isBlindReceipt;
                            }
                            setCart(cartData);
                            localStorage.removeItem("selectedReturnType");
                            useTransactionStore.getState().setSelectedReturnType(null);
                            localStorage.removeItem("exchangeCartObj");
                          }
                        }}
                        style={{ fontSize: "1.2vw", marginTop: "-1vh", cursor: "pointer" }}
                      />
                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                      <div style={{ width: "75%" }}>
                        <Input
                          ref={productPanelSearchRef}
                          placeholder="Search for products by code/name"
                          id="sm-product-search"
                          onChange={(e) => {
                            const value = e.target.value;
                            setProductSearchInput(value);
                            keyboard?.current?.setInput(value);
                            debouncedSearch(value);
                          }}
                          className="sm-product-search-panel"
                          style={{ borderRadius: "7px", padding: "0.8vh 0.8vw", border: "1px solid #d9d9d9" }}
                          value={productSearchInput}
                          onFocus={() => {
                            setOpen(true);
                            setTimeout(() => {
                              setInputName("productSearch1");
                              keyboard?.current?.setInput(productSearchInput);
                            }, 150);
                          }}
                          onPressEnter={handleSearchEnter}
                          suffix={
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {productSearchInput?.length > 0 ? (
                                <CloseSquareFilled
                                  style={{ fontSize: "20px", color: "#2F3856" }}
                                  onClick={async () => {
                                    setProductSearchInput("");
                                    debouncedSearch("");
                                    setTimeout(() => {
                                      setOpen(false);
                                      const productSearchInput = document.getElementById("sm-product-search");
                                      if (productSearchInput) {
                                        productSearchInput.blur();
                                      }
                                      keyboard?.current?.setInput("");
                                    }, 200);
                                  }}
                                />
                              ) : null}
                            </div>
                          }
                          prefix={<img src={SearchIcon} alt="" onClick={handleSelectProduct} style={{ cursor: "pointer" }} />}
                        />
                        <Button
                          // type="primary"
                          onClick={handleFetchSingleProduct}
                          loading={isFetchingProduct}
                          disabled={!productSearchInput?.trim()}
                          style={{
                            height: "5vh",
                            width: "130px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#2F3856",
                            color: "#fff",
                            borderRadius: "7px",
                          }}
                        >
                          Fetch Item
                        </Button>
                      </div>
                      <Select
                        className="selecItem"
                        placeholder={
                          <span style={{ paddingTop: "2em" }} className="cartSelect">
                            Sort
                          </span>
                        }
                        suffixIcon={<img src={MoreOptionsIcon} alt="" style={{ height: "1vh", marginBottom: "15%" }} />}
                        value={sortOrder}
                        onChange={handleSortChange}
                        allowClear
                        onClear={() => {
                          setSortOrder(null);
                          filterProducts(selectedProductBrand, selectCategoryList, productSearchInput, priceRange);
                        }}
                        style={{ marginLeft: "1vw" }}
                      >
                        <Option className="cartOption" key="price_asc" value="price_asc">
                          Price: Low to High
                        </Option>
                        <Option className="cartOption" key="price_desc" value="price_desc">
                          Price: High to Low
                        </Option>
                        <Option className="cartOption" key="name_asc" value="name_asc">
                          Name: A to Z
                        </Option>
                      </Select>
                      <Button.Group style={{ width: "8%", height: "5vh", marginLeft: "0.6vw" }}>
                        <Button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "3vw",
                            borderTopLeftRadius: "5px",
                            borderBottomLeftRadius: "5px",
                            margin: "0 0 0 0.5vw",
                            height: "inherit",
                            borderColor: "#fff",
                            backgroundColor: productsDisplay === "super-market" ? "#2F3856" : "",
                          }}
                        >
                          <img src={filterList} style={{ height: "2.3vh" }} />
                        </Button>
                        <Button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "3vw",
                            borderTopRightRadius: "5px",
                            borderBottomRightRadius: "5px",
                            height: "inherit",
                            backgroundColor: productsDisplay === "superMarket" ? "#2F3856" : "",
                          }}
                        >
                          <img src={productsDisplay === "super-market" ? gridFilterInActive : gridFilter} style={{ height: "2.3vh" }} />
                        </Button>
                      </Button.Group>
                    </div>
                    <Scrollbars className="productScroll1">
                      {productsList.map((obj, i) => (
                        <Row
                          gutter={[15, 11]}
                          style={{ width: "99%", backgroundColor: "#fff", marginTop: "1.5vh", height: "13vh", marginLeft: "-0.1vw", borderRadius: "10px", fontSize: "1vw" }}
                        >
                          <Col span={4}>
                            <img
                              style={{
                                width: "100%",
                                height: "11vh",
                                objectFit: "contain",
                                borderRadius: "5px",
                                paddingTop: "1vh",
                                alignSelf: "center",
                              }}
                              src={obj.imageurl || DefaultProductImage}
                              alt=""
                            />
                          </Col>
                          <Col span={16}>
                            <div style={{ maxWidth: "100%", overflow: "hidden", paddingTop: "1vh" }}>
                              <label
                                style={{ ...data.posScreenStyles.productsCard.cardDetails.productDescr, whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                                className="productName"
                              >
                                {obj["description"]}
                              </label>
                            </div>
                            <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                              {obj["name"]}
                              <span style={{ display: "block" }}>{obj["value"]}</span>
                            </p>
                          </Col>
                          <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            <span className="productDescription-kiosk" title={obj["description"]}>
                              {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              {obj.sunitprice} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{obj["uomName"]}
                            </span>
                            <span
                              onClick={() => {
                                pickProduct(obj);
                              }}
                              style={{
                                fontSize: "0.8em",
                                color: "#fff",
                                backgroundColor: "#2F3856",
                                padding: "1vh 2.5vw",
                                marginTop: "2%",
                                borderRadius: "3px",
                                cursor: "pointer",
                              }}
                            >
                              ADD
                            </span>
                          </Col>
                          <span tabIndex={0}></span>
                        </Row>
                      ))}
                    </Scrollbars>
                  </>
                )}
              </Col>
            </Row>
          )}
        </Drawer>
      )}
      <ProductPanelTable
        stockDrawerVisible={stock.stockDrawerVisible}
        selectedStockProduct={stock.selectedStockProduct}
        stockLoading={stock.stockLoading}
        stockList={stock.stockList}
        selectedStockRow={stock.selectedStockRow}
        setSelectedStockRow={stock.setSelectedStockRow}
        requestQty={stock.requestQty}
        setRequestQty={stock.setRequestQty}
        transformedRows={stock.transformedRows}
        currenciesList={currenciesList}
        handleStockTransferRequest={stock.handleStockTransferRequest}
        closeStockDrawer={stock.closeStockDrawer}
      />
    </React.Fragment>
  );
};

export default ProductPanelSM;
